import {
  Inbox,
  PackageOpen,
  SearchX,
  ShoppingBag,
} from "lucide-react";

const defaultIcons = {
  orders: ShoppingBag,
  inventory: PackageOpen,
  search: SearchX,
  default: Inbox,
};

function EmptyState({
  icon: CustomIcon,
  iconType = "default",
  title = "Nothing here yet",
  description = "There is no information to display right now.",
  actionLabel,
  onAction,
  secondaryActionLabel,
  onSecondaryAction,
  compact = false,
}) {
  const Icon =
    CustomIcon ||
    defaultIcons[iconType] ||
    defaultIcons.default;

  return (
    <div
      className={[
        "empty-state",
        compact ? "empty-state--compact" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="empty-state__icon" aria-hidden="true">
        <Icon size={compact ? 24 : 32} />
      </div>

      <div className="empty-state__content">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>

      {(actionLabel || secondaryActionLabel) && (
        <div className="empty-state__actions">
          {actionLabel && (
            <button
              type="button"
              className="btn btn--primary"
              onClick={onAction}
            >
              {actionLabel}
            </button>
          )}

          {secondaryActionLabel && (
            <button
              type="button"
              className="btn btn--secondary"
              onClick={onSecondaryAction}
            >
              {secondaryActionLabel}
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default EmptyState;